var map = {
	"./Avator.png": "f3ec",
	"./graph.png": "60fd",
	"./handshake.png": "e46a",
	"./hudsonmann.png": "e0f1",
	"./megaphone.png": "82f9",
	"./profile.png": "fb51",
	"./profile_old.png": "dd35",
	"./talentkeepers.png": "dc4f",
	"./tamara.png": "17fa",
	"./testimonial.png": "97c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d3ed";